import React from "react";
import { BookStore, HighlightStore, Dispatcher } from "../../flux";
import {
  SearchField,
  StickyList,
  SectionHeader,
  Isvg,
  MenuMixin
} from "../../components";
import { VstDropdown } from "vstui";
import { Button } from "@vitalsource/vstui";
import SearchResult from "./search-result";
import AllBookSearch from "./all-book-search";
import { FilterKnobs as Filter } from "@vitalsource/vstui-icons";
import AccessibleSearchResults from "../../../accessability/accessibleSearchResults";

const Error = {
  TIMEOUT: "TIMEOUT",
  UNKNOWN: "UNKNOWN"
};

function isTimeout(response) {
  return (
    // Undefined results = timeout. Empty array results = success, no match
    response.isSuccess() && response.data && response.data.results === undefined
  );
}

class SearchContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
      searchTerm: false,
      extraTerms: [],
      searchValue: props.query,
      currentBook: props.isbn,
      filter: "content",
      filteredHighlights: "all",
      sort: "az",
      searchHighlightResults: 0,
      searchOnOpen: props.searchOnOpen
    };

    this._pageReady = this._pageReady.bind(this);
    this._updateSearch = this._updateSearch.bind(this);
    this._embeddedReceiver = this._embeddedReceiver.bind(this);
    this._forceSearch = this._forceSearch.bind(this);
    this._changeSearch = this._changeSearch.bind(this);
    this._search = this._search.bind(this);
    this._breakUpResult = this._breakUpResult.bind(this);
    this._getChapterResults = this._getChapterResults.bind(this);
    this._getBookListResults = this._getBookListResults.bind(this);
    this._highlightTermInBook = this._highlightTermInBook.bind(this);
    this._searchTerm = this._searchTerm.bind(this);
    this._searchAllBooks = this._searchAllBooks.bind(this);
    this._goToSearch = this._goToSearch.bind(this);
    this._updateSingleBookISBN = this._updateSingleBookISBN.bind(this);
    this._closePanelEvent = this._closePanelEvent.bind(this);
    this._sortByAZ = this._sortByAZ.bind(this);
    this._sortByZA = this._sortByZA.bind(this);
    this._toggleSort = this._toggleSort.bind(this);
    this._resetSearch = this._resetSearch.bind(this);
    this._hideFilter = this._hideFilter.bind(this);
    this._showFilter = this._showFilter.bind(this);
    this._openNotebook = this._openNotebook.bind(this);
    this._renderFilter = this._renderFilter.bind(this);
    this._renderSearchContents = this._renderSearchContents.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    !!this.props.query && this._searchTerm(this.state.searchValue);
    window.addEventListener("message", this._embeddedReceiver, false);
    window.addEventListener("update-search-term", this._updateSearch);
    if (this.props.isbn) {
      Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
      Dispatcher.bind(Dispatcher.BOOK_PAGE_READY, this._pageReady);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("update-search-term", this._updateSearch);
    window.removeEventListener("message", this._embeddedReceiver);
    if (this.props.isbn) {
      Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
      Dispatcher.removeListener(Dispatcher.BOOK_PAGE_READY, this._pageReady);
      BookStore.get(this.props.isbn).viewer.Book.unhighlightTerms();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this._updateSearch({ value: nextProps.searchOnOpen });
  }

  _pageReady(isbn, e, data) {
    const book = BookStore.get(this.props.isbn);
    if (this.state.searchValue && this.state.searchValue.length > 0) {
      this._highlightTermInBook([
        this.state.searchValue,
        ...this.state.extraTerms
      ]);
    } else {
      book.viewer.Book.unhighlightTerms();
    }
  }

  _updateSearch(e) {
    if (e.value && e.value.length > 0 && e.value !== this.state.titleTerm) {
      if (this._isMounted) {
        this.setState({ searchValue: e.value, titleTerm: e.value });
      }
      this._searchTerm(e.value);
    }
  }

  _embeddedReceiver(e) {
    if (e.data.indexOf && e.data.indexOf("fraction:event:search:") !== -1) {
      var term = e.data.split(":").reverse()[0];
      this._forceSearch(term);
    }
  }

  _forceSearch(term) {
    this.setState({ searchValue: term });
    if (this.currentTextSearch) {
      clearTimeout(this.currentTextSearch);
    }
    var query = term.toLowerCase();
    this._searchTerm(query);
  }

  _changeSearch(value, callback) {
    const book = BookStore.get(this.props.isbn);
    if (this.state.currentBook) {
      if (value.length >= 3) {
        this._highlightTermInBook(value);
      } else {
        book.viewer.Book.unhighlightTerms();
      }
    }
    this.setState({ searchValue: value }, () => {
      callback && callback();
    });
  }

  _search(e) {
    this._searchTerm(this.state.searchValue);
  }

  _breakUpResult(result, query) {
    var end = 0,
      start;
    var chunks = [];
    for (var i = 0; i < (result.term_locs && result.term_locs.length); i++) {
      var chunk;
      var thisLoc = result.term_locs[i];
      var highlightLocPos = thisLoc.pos;
      var beginningEllipsis = "... ",
        endingEllipsis = " ...";
      if (thisLoc.pos < end) {
        var lastChunk = chunks[chunks.length - 1];
        lastChunk.highlightLocPos.push(
          highlightLocPos + beginningEllipsis.length - start
        );
        lastChunk.highlightLength.push(thisLoc.len);
        continue;
      }
      start = Math.max(end, thisLoc.pos - 165); // get some space before the term
      end = thisLoc.pos + thisLoc.len + 165;
      end = result.text.indexOf(" ", end);
      if (end > result.text.length - 1 || end === -1) {
        end = result.text.length;
        endingEllipsis = "";
      }
      start = start === 0 ? start : result.text.indexOf(" ", start) + 1;
      if (end < 0) {
        end = result.text.length;
      }
      if (
        start === 0 ||
        (start > 3 &&
          result.text.indexOf(".", start - 3) < i &&
          result.text.indexOf(".", start - 3) >= 0)
      ) {
        beginningEllipsis = "";
      }
      highlightLocPos += beginningEllipsis.length - start;
      if (end >= 0) {
        chunk = {
          text:
            beginningEllipsis +
            result.text.substring(start, end) +
            endingEllipsis,
          cfi: result.cfi,
          highlightLocPos: [highlightLocPos],
          highlightLength: [thisLoc.len]
        };
      } else {
        chunk = {
          text: beginningEllipsis + result.text.substring(start),
          cfi: result.cfi,
          highlightLocPos: [highlightLocPos],
          highlightLength: [thisLoc.len]
        };
      }
      chunks.push(chunk);
    }
    return chunks;
  }

  _getChapterResults(results, query, external, isbn) {
    var chapterResults = {};
    if (results) {
      var re = new RegExp("\\b(" + query + ")\\b", "ig");
      for (var i = 0; i < results.length; i++) {
        var result = results[i];
        var title = result.chapter_title;
        result.searchedTerm = query;
        chapterResults[title] = chapterResults[title] || []; // init if null
        var chunks = this._breakUpResult(result, query);
        chunks.map(chunkedResult => {
          chunkedResult.external = external;
          chapterResults[title].push({
            cfi: chunkedResult.cfi,
            contentType: true,
            highlightType: false,
            noteType: false,
            content: (
              <SearchResult
                result={chunkedResult}
                originalResult={result}
                regex={re}
                showPage={!isbn || isbn === this.props.isbn}
                isbn={isbn || this.props.isbn}
                goToSearch={this._goToSearch}
                cfi={chunkedResult.cfi}
                key={
                  "search-result-" +
                  query +
                  "-" +
                  i +
                  "-" +
                  chunkedResult.text.hashMe()
                }
              />
            )
          });
        });
      }
    }
    return chapterResults;
  }

  _getBookListResults(chapterResults) {
    var bookListResults = [];
    for (var o = 0; o < Object.keys(chapterResults).length; o++) {
      var chapter = Object.keys(chapterResults)[o];
      var thisChapterResults = [];
      for (var i = 0; i < chapterResults[chapter].length; i++) {
        var result = chapterResults[chapter][i];
        thisChapterResults.push(result);
      }
      bookListResults.push({ header: chapter, children: thisChapterResults });
    }
    return bookListResults;
  }

  _highlightTermInBook(terms) {
    terms = (Array.isArray(terms) ? terms : [terms])
      .map(t => t.trim().split(/\s+/))
      // SEE ALTERNATIVES TO FLAT HERE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
      .reduce((acc, val) => acc.concat(val), [])
      .filter(t => t && t !== "");

    if (this.state.currentBook && terms.length > 0) {
      const book = BookStore.get(this.props.isbn);
      book.viewer.Book.highlightTerm({ term: terms, color: "#ffa758" });
    }
  }

  _searchTerm(query) {
    if (query.length === 0) {
      this.setState({
        searchInProgress: false,
        currentBookListResults: false,
        searchHighlightResults: false,
        searchTerm: false,
        bookSearchResults: false,
        extraTerms: []
      });
      return;
    }
    if (query === "watkins") {
      Fraction.Helpers.showWatkins = true;
    }
    this._highlightTermInBook(query);
    this.setState({ searchTerm: false, searchInProgress: true });
    query = query.toLowerCase();
    if (
      !this.state.currentBookListResults ||
      this.state.currentBookListResults.length === 0
    ) {
      Fraction.Helpers.addLoader(
        $(".search-content"),
        "background:transparent;"
      );
    } else {
      Fraction.Helpers.addLoader($(".search-content"), "bottom:44px;");
    }
    if (this.state.currentBook) {
      this.currentTextSearch = setTimeout(() => {
        if (query.length >= 1) {
          const book = BookStore.get(this.props.isbn);
          const onSuccess = response => {
            if (
              response.isSuccess() &&
              response.data &&
              response.data.results
            ) {
              // highlight extra terms if there are more that are returned from search
              let extraTerms = [];
              if (
                response.data.results[0] &&
                response.data.results[0].extra_terms
              ) {
                extraTerms = response.data.results[0].extra_terms;
              }

              this._highlightTermInBook([query, ...extraTerms]);

              // Split into chapters (current book)
              const chapterResults = this._getChapterResults(
                response.data.results,
                query
              );
              const highlights = HighlightStore.searchHighlights(
                this.props.isbn,
                query,
                true,
                true
              );
              const currentBookListResults = this._getBookListResults(
                chapterResults
              );

              this.setState({
                currentBookListResults: currentBookListResults,
                searchTerm: query,
                searchError: null,
                searchInProgress: false,
                searchHighlightResults: highlights.length,
                extraTerms
              });
            } else {
              this.setState({
                currentBookListResults: [],
                searchError: isTimeout(response)
                  ? Error.TIMEOUT
                  : Error.UNKNOWN,
                searchTerm: query,
                searchInProgress: false,
                searchHighlightResults: 0,
                extraTerms: []
              });
            }
            Fraction.Helpers.removeLoader($(".search-content"));
          };
          book.viewer.Book.waldoSearchContent(query, onSuccess);
          Fraction.Reporter.gaEvent(
            "V3/reader-search",
            query,
            "performInBookSearch"
          );
          Fraction.Reporter.gaEvent(
            "reader/panel/search/" +
              (this.state.currentBook ? "single-book" : "all-books") +
              "/search",
            query
          );
        } else {
          Fraction.Helpers.removeLoader($(".search-content"));
          this.setState({
            searchResults: [],
            searchTerm: false,
            searchInProgress: false,
            extraTerms: []
          });
        }
      }, 250);
    } else {
      this._searchAllBooks(query);
    }
  }

  _searchAllBooks(query) {
    this.bookSearchResults = [];
    var emptyObj = Object.create(null);
    var result = [];
    this.setState({
      bookSearchResults: [],
      searching: true,
      searchTerm: query
    });
    Fraction.Helpers.removeLoader($(".search-content"));
    Fraction.Helpers.addLoader($(".search-content"), "background:transparent;");
    Fraction.Reporter.gaEvent(
      this.props.isbn ? "V3/reader-search" : "V3/library-search",
      query,
      "performAllBookSearch"
    );
    Jigsaw.waldoSearch(
      query,
      { order: "viewed" },
      response => {
        // add results
        if (response.isSuccess() && response.data && response.data.results) {
          this.bookSearchResults = this.bookSearchResults.concat(
            response.data.results
          );
          if (response.data.results.length > 0) {
            for (var i = 0; i < response.data.results.length; i++) {
              if (response.data.results[i].count > 0) {
                Fraction.Helpers.removeLoader($(".search-content"));
                if (this._isMounted) {
                  this.setState({ longSearch: true });
                }
              }
            }
          }

          for (i = 0; i < this.bookSearchResults.length; i++) {
            if (!emptyObj[this.bookSearchResults[i].isbn]) {
              emptyObj[this.bookSearchResults[i].isbn] = true;
              result.push(this.bookSearchResults[i]);
            }
          }

          if (this._isMounted) {
            this.setState({ bookSearchResults: result });
          } else {
            this.state.bookSearchResults = result;
          }
        }
      },
      response => {
        // done searching
        if (this._isMounted) {
          this.setState({ longSearch: false, searching: false });
          Fraction.Helpers.removeLoader($(".search-content"));
        } else {
          this.state.longSearch = false;
        }
      }
    );
  }

  _goToSearch(result) {
    const book = BookStore.get(this.props.isbn);
    if (this.state.currentBook && !result.external) {
      book.viewer.Book.goToSearchResult(result, () => {
        this._highlightTermInBook([
          result.searchTerm,
          ...this.state.extraTerms
        ]);
      });
      if (Fraction.Helpers.isSmallScreen()) {
        this.props.close("skipGA");
      }
    } else {
      if (result.cfi) {
        Fraction.Router.setRoute("/");
        Fraction.Router.setRoute(
          "/books/" +
            this.state.singleBookIsbn +
            "/cfi/" +
            result.cfi +
            "?search=" +
            this.state.searchValue
        );
      } else {
        Fraction.Router.setRoute("/");
        Fraction.Router.setRoute(
          "/books/" +
            this.state.singleBookIsbn +
            "/content/element/" +
            result.id +
            "?search=" +
            this.state.searchValue
        );
      }
    }
    if (this.state.currentBook) {
      Fraction.Reporter.gaEvent(
        this.props.isbn ? "V3/reader-search" : "V3/library-search",
        result.searchedTerm,
        "navigateToResultFromCurrentBook"
      );
    } else {
      Fraction.Reporter.gaEvent(
        this.props.isbn ? "V3/reader-search" : "V3/library-search",
        result.searchedTerm,
        "navigateToResultFromAllBooks"
      );
    }
    Fraction.Reporter.gaEvent(
      "reader/panel/search/" +
        (this.state.currentBook ? "single-book" : "all-books") +
        "/navigate-to-search-result"
    );
  }

  _updateSingleBookISBN(isbn) {
    this.setState({ singleBookIsbn: isbn });
  }

  _closePanelEvent() {
    if (!this.props.isbn) {
      Fraction.Reporter.gaEvent(
        "V3/library-search",
        "search:close",
        "closeLibrarySearch"
      );
    }
    Fraction.Helpers.removeModal();
  }

  _sortByAZ(e) {
    this.setState({ sort: "az" });
    MenuMixin._removeMenu();
  }

  _sortByZA(e) {
    this.setState({ sort: "za" });
    MenuMixin._removeMenu();
  }

  _toggleSort() {
    this.setState(prevState => ({ sortOpen: !prevState.sortOpen }));
  }

  _resetSearch() {
    this.setState({
      searchResults: [],
      currentBook: this.props.isbn,
      filter: "content",
      filteredHighlights: "all",
      sort: "az",
      searchHighlightResults: 0,
      bookSearchResults: null,
      currentBookListResults: [],
      searchOnOpen: this.props.searchOnOpen,
      searchTerm: null,
      searchValue: null,
      titleTerm: null
    });
  }

  _hideFilter(scrollTop) {
    if (
      $(".search-header").css("display") === "none" &&
      !this.animatingFilter
    ) {
      this.animatingFilter = true;
      scrollTop = Math.max(0, scrollTop);
      $("#search-container .search-content").stop();
      $("#search-container .search-content").animate(
        {
          top: 0
        },
        50,
        () => {
          this.animatingFilter = false;
        }
      );
      $("#search-container .filter-and-sort-bar").stop();
      $("#search-container .filter-and-sort-bar").animate(
        {
          marginTop: -35
        },
        50
      );
      $(".search-footer").stop();
      $(".search-footer").animate(
        {
          bottom: -58
        },
        50
      );
    }
  }

  _showFilter(scrollTop) {
    if (
      (!this.animatingFilter &&
        $(".search-header").css("display") === "none") ||
      parseInt($("#search-container .search-content").css("top"), 10) < 30
    ) {
      this.animatingFilter = true;
      scrollTop = Math.min(35, scrollTop);
      $("#search-container .search-content").stop();
      $("#search-container .search-content").animate(
        {
          top: $(".search-header").css("display") === "none" ? 35 : 65
        },
        50,
        () => {
          this.animatingFilter = false;
        }
      );
      $("#search-container .filter-and-sort-bar").stop();
      $("#search-container .filter-and-sort-bar").animate(
        {
          marginTop: 0
        },
        50
      );
      $(".search-footer").stop();
      $(".search-footer").animate(
        {
          bottom: 0
        },
        50
      );
    }
  }

  _stuckTouchStart(e) {
    e.preventDefault();
  }

  _openNotebook(e) {
    Dispatcher.emit(Dispatcher.HIDE_ALL_PANELS);
    Dispatcher.emit(Dispatcher.SHOW_PANEL, "notebook");
    setTimeout(() => {
      Fraction.Helpers.fireEvent("update-filter-term", {
        value: this.state.searchTerm
      });
      this.setState({ initialNotebookFilter: this.state.searchTerm });
    }, 0);
  }

  _renderFilter() {
    const target = (
      <Button label={i18n.t("base.sort")} naked iconStart={<Filter />} />
    );

    return (
      <div id="search-filter">
        <VstDropdown
          className="vst-dropdown-highlights-filters"
          vertical="bottom"
          horizontal="right"
          headerTitle={i18n.t("base.filter")}
          subheaderTitle={i18n.t("base.filter")}
          headerBackButton={<Isvg src="img/arrow_white_left.svg" />}
          isMobile={Fraction.Helpers.isSmallScreen()}
          target={target}
          onOpen={() => this.setState({ menuOpen: "filters" })}
          onClose={() => this.setState({ menuOpen: null })}
        >
          <VstDropdown.Item role="subheader">
            {i18n.t("sorting.sort-by")}
          </VstDropdown.Item>
          <VstDropdown.Item
            onClick={this._sortByAZ}
            selected={this.state.sort === "az"}
          >
            {i18n.t("sorting.book-order-az")}
          </VstDropdown.Item>
          <VstDropdown.Item
            onClick={this._sortByZA}
            selected={this.state.sort === "za"}
          >
            {i18n.t("sorting.book-order-za")}
          </VstDropdown.Item>
        </VstDropdown>
      </div>
    );
  }

  _renderSearchContents() {
    if (this.state.searchTerm) {
      return (
        <div className="null-screen">
          {this.state.currentBookListResults &&
          this.state.currentBookListResults.length > 0 ? (
            <div>
              {i18n.t("filter.no-results-for-filter", {
                term: this.state.searchTerm
              })}
            </div>
          ) : this.state.searchError === Error.TIMEOUT ? (
            <div>
              {i18n.t("reader.search.too-long", {
                term: this.state.searchTerm
              })}
            </div>
          ) : this.state.searchError === Error.UNKNOWN ? (
            <div>{i18n.t("reader.search.generic-error")}</div>
          ) : (
            <div>
              {Fraction.Brand.Graphics.watkins && (
                <img
                  alt=""
                  className="watkins"
                  src="/img/prop_laptop_dust.svg"
                />
              )}
              <h2 id="nothing-here">{i18n.t("filter.nothing-here")}</h2>
              {i18n.t("filter.no-results-for-find", {
                term: this.state.searchTerm
              })}
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="null-screen">
          {Fraction.Brand.Graphics.watkins ? (
            <Isvg className="watkins" src="/img/watkins_search.svg" />
          ) : (
            <Isvg className="watkins null" src="/img/null_search.svg" />
          )}
          <div>{i18n.t("reader.search.begin")}</div>
        </div>
      );
    }
  }

  render() {
    var filteredList = [];
    var totalResults = 0;

    if (this.state.currentBook && this.state.currentBookListResults) {
      this.state.currentBookListResults.forEach(result => {
        var toAdd = [];
        result.children.forEach(child => {
          if (
            this.state.filter === "all" ||
            (this.state.filter === "content" && child.contentType) ||
            (this.state.filter === "highlights" && child.highlightType) ||
            (this.state.filter === "notes" && child.noteType)
          ) {
            // now check for highlight type
            if (
              child.contentType ||
              this.state.filteredHighlights === "all" ||
              (child.shared && this.state.filteredHighlights === "others") ||
              (!child.shared && this.state.filteredHighlights === "me")
            ) {
              toAdd.push(child.content);
            }
          }
        });
        if (toAdd.length > 0) {
          totalResults += toAdd.length;
          filteredList.push({
            header: (
              <SectionHeader
                title={result.header}
                count={toAdd.length}
                key={
                  "search-section-header-" + result.header + "-" + toAdd.length
                }
              />
            ),
            body: {
              className: "notecard-list",
              contentList: toAdd
            }
          });
        }
      });
      if (this.state.sort === "za") {
        filteredList = filteredList.reverse();
      } else if (this.state.sort === "ch") {
        filteredList = filteredList.slice().sort((a, b) => {
          // Groups with more results come first. If result counts are equal, preserve default ordering.
          const diff = b.body.contentList.length - a.body.contentList.length;
          return diff === 0
            ? filteredList.indexOf(a) - filteredList.indexOf(b)
            : diff;
        });
      }
    } else if (this.state.singleBookListResults) {
      this.state.singleBookListResults.forEach(result => {
        var toAdd = [];
        result.children.forEach(child => {
          toAdd.push(child.content);
        });
        if (toAdd.length > 0) {
          totalResults += toAdd.length;
          filteredList.push({
            header: (
              <SectionHeader
                title={result.header}
                count={toAdd.length}
                key={
                  "search-section-header-" + result.header + "-" + toAdd.length
                }
              />
            ),
            body: {
              className: "notecard-list",
              contentList: toAdd
            }
          });
        }
      });
      if (this.state.sort === "za") {
        filteredList = filteredList.reverse();
      }
    }

    var stuckHeader;
    var searchContents = this._renderSearchContents();

    if (this.state.searchInProgress) {
      searchContents = <span />;
    }
    if (this.state.currentBook) {
      if (filteredList.length > 0) {
        searchContents = (
          <StickyList
            listItems={filteredList}
            scrollUp={this._showFilter}
            scrollDown={this._hideFilter}
          />
        );
      }
    } else if (
      this.state.bookSearchResults &&
      this.state.bookSearchResults.length > 0
    ) {
      searchContents = (
        <AllBookSearch
          searching={this.state.searching}
          bookSearchResults={this.state.bookSearchResults}
          updateSingleBookISBN={this._updateSingleBookISBN}
          searchValue={this.state.searchTerm}
          getChapterResults={this._getChapterResults}
          getBookListResults={this._getBookListResults}
          isbn={this.props.isbn}
          key="all-book-search"
        />
      );
    }

    return (
      <div id="search-container" className="search-panel">
        {this.props.modalHeader ? (
          <div className="modal-header">
            <div className="panel-title">
              <button
                className="panel-button close-panel noButton"
                onClick={this._closePanelEvent}
              >
                <span className="offScreen">{i18n.t("base.close-button")}</span>
              </button>
            </div>
            <SearchField
              onChange={this._changeSearch}
              search={this._searchTerm}
              value={this.state.searchValue}
              reset={this._resetSearch}
              placeholder={
                this.state.currentBook
                  ? i18n.t("reader.panels.search-book")
                  : i18n.t("reader.panels.search-books")
              }
            />
          </div>
        ) : (
          <div className="search-header panel-header-container">
            <SearchField
              onChange={this._changeSearch}
              search={this._searchTerm}
              value={this.state.searchValue}
              reset={this._resetSearch}
              placeholder={
                this.state.currentBook
                  ? i18n.t("reader.panels.search-book")
                  : i18n.t("reader.panels.search-books")
              }
            />
          </div>
        )}
        {this.state.longSearch && <div className="subtle-loader" />}
        {!!totalResults && (
          <div id="search-results-container">
            <div className="result-count">
              <AccessibleSearchResults
                result={i18n.pluralize(
                  totalResults,
                  "reader.search.one-result",
                  "reader.search.results"
                )}
              />
            </div>
            {this._renderFilter()}
          </div>
        )}

        <div
          id="search-content"
          className={
            "search-content " + (this.props.noFilter ? "noFilter" : "")
          }
          style={{ top: totalResults ? "90px" : "55px" }}
        >
          {stuckHeader}
          <div
            className={"sub-result-list" + (stuckHeader ? " active" : "")}
            onScroll={this._scrollAllBooks}
          >
            <h3 className="offScreen">
              {i18n.t("reader.panels.search-results")}
            </h3>
            {searchContents}
          </div>
        </div>
      </div>
    );
  }
}

let searchTitle = "";
const searchChange = (value, callback) => {
  searchTitle = value;
  callback && callback();
};
const search = value => {
  Fraction.Helpers.fireEvent("update-search-term", { value: value });
  searchTitle = value;
};

const searchField = (
  <SearchField
    type="search"
    onChange={searchChange}
    value={searchTitle}
    search={search}
    placeHolder={i18n.t("reader.panels.search-books")}
  />
);
//TODO open notebook with filter ::: this._searchComponent = this._searchComponent || <SearchContainer key="search-container" isbn={this.props.isbn} titleTerm={this.state.titleSearchTerm} close={this._searchButtonEvent} openNotebookWithFilter={this._openNotebookWithFilter} />;

const gadgetId = "search";
module.exports = {
  class: SearchContainer,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      type: "panel",
      enabled: () => Fraction.Brand.Sidebar.Buttons.search,
      hideInMobile: true,
      panelTitle: (
        <span>
          <span className="respond-desktop">
            {i18n.t("reader.panels.search")}
          </span>
          <div className="respond-mobile">{searchField}</div>
        </span>
      ),
      sidebar: {
        icon: "/img/search/search.svg",
        action: () => {
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};

SearchContainer.defaultProps = {
  query: ""
};
